import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';

export function FN_GRAPH__layout_create(graph: DTO_GRAPH__instance) {
  graph.dagre__autolayout();
}
